import { FullLogo } from '@c/icons';
import Image from 'next/image';
import Link from 'next/link';
import SocialLink from '@ui/Link/SocialLink';
import React from 'react';

const LandingPageFooter: React.FC = () => {
  return (
    <footer className="bg-black px-5 md:px-8 pb-16">
      {/* Top row */}
      <div className="flex items-center md:item-end justify-between gap-5 py-10 flex-col md:flex-row">
        <div className="flex gap-8 md:gap-12 flex-col lg:flex-row">
          <div className="flex">
            
            <Link href="/">
              <FullLogo variant="white" height={32} width={160} />
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-4 md:gap-6 lg:gap-8 flex-wrap justify-center">
            {[
              { label: 'Cameras', href: '/c/digital-cameras' },
              { label: 'Lenses', href: '/c/photo-video-lenses' },
              { label: 'Video', href: '/c/video-camcorders' },
              { label: 'Vintage', href: '/c/vintage-camera-equipment' },
              { label: 'Lighting', href: '/c/lighting-studio' },
              { label: 'Drones', href: '/c/drones-aerial-imaging' },
              { label: 'Computers', href: '/c/computers-electronics' },
              { label: 'Accessories', href: '/c/photo-video-accessories' },
            ].map(({ label, href }) => (
              <div key={label}>
                <Link
                  href={href}
                  className="text-white text-[15px] font-medium hover:text-[#ED7523] transition-colors duration-300"
                >
                  {label}
                </Link>
              </div>
            ))}
          </div>

        </div>

        <Link href="/sell">
          <button className="hidden md:block bg-[#ED7523] text-white cursor-pointer py-2 px-6 rounded-[10px] font-medium text-[16px]">
            Sell Your Gear
          </button>
        </Link>

      </div>

      <div className="w-full md:hidden gap-4">
        <div className="max-width-[496px] mx-auto flex flex-col">
          <Link
            href="/products"
            className="pb-6 text-white text-[15px] font-medium hover:text-[#ED7523] transition-colors duration-300"
          >
            Buy Gear
          </Link>
          <div className="py-6 border-t border-white">
            <Link
              href="/sell"
              className="text-white text-[15px] font-medium hover:text-[#ED7523] transition-colors duration-300"
            >
              Sell Gear
            </Link>
          </div>
        </div>
      </div>

      {/* Bottom row */}
      <div className="py-6 border-y border-white w-full flex justify-between items-center gap-10 flex-col md:flex-row">
        <div className="w-full max-w-[496px] grid grid-cols-3 gap-5 md:gap-10 text-left">

          {/* --- Mobile Only: Column 1 --- */}
          <div className="block md:hidden">
            <ul>
              {[
                { label: 'Blog', href: '/blog' },
                { label: 'Help', href: '/help' },
              ].map((item) => (
                <li key={item.label}>
                  <Link
                    href={item.href}
                    className="text-white text-[15px] font-light hover:underline transition-all duration-300 leading-[180%]"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* --- Column 2 (Shared) --- */}
          <div>
            <ul>
              {[
                { label: 'About Us', href: '/about' },
                { label: 'Contact Us', href: '/contact-us' },
                { label: 'Blog', href: '/blog' },
              ].map((item) => (
                <li key={item.label}>
                  <Link
                    href={item.href}
                    className="text-white text-[15px] font-light hover:underline transition-all duration-300 leading-[180%]"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* --- Column 3 (Shared) --- */}
          <div>
            <ul>
              {[
                { label: 'How it Works', href: '#how-it-works' },
                { label: 'Terms of Use', href: '/policies/terms' },
                { label: 'Privacy Policy', href: '/policies/privacy-policy' },
              ].map((item) => (
                <li key={item.label}>
                  <Link
                    href={item.href}
                    className="text-white text-[15px] font-light hover:underline transition-all duration-300 leading-[180%]"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* --- Desktop Only: Column 1 --- */}
          <div className="hidden md:block">
            <ul>
              {[
                { label: 'Why GearFocus', href: '#why-gearfocus' },
                { label: 'Start Selling', href: '/sell' },
                { label: 'FAQs', href: '#faqs' },
              ].map((item) => (
                <li key={item.label}>
                  <Link
                    href={item.href}
                    className="text-white text-[15px] font-light hover:underline transition-all duration-300 leading-[180%]"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
        
        {/* Social icons */}
        <div className="flex justify-center gap-4 md:justify-start">
          <SocialLink variant="instagram" color="fill-white" />
          <SocialLink variant="youtube" color="fill-white" />
          <SocialLink variant="pinterest" color="fill-white" />
          <SocialLink variant="facebook" color="fill-white" />
        </div>

      </div>

      <div className="block md:hidden text-white text-[10px] font-light text-center mt-6">
        ©2026 GearFocus   All Rights Reserved
      </div>
    </footer>
  );
};

export default LandingPageFooter;
